import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../common-service';
import { GetGuideGrievanceNotificationToRegisterPageResponse } from '../../responses/hospital-document/get-guide-grievance-notification-to-register-page.response';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { GetListGrievanceNotificationResponse } from '../../responses/hospital-document/get-list-grievance-notification.response';
import { GuideGrievanceNotificationReportResponse } from '../../responses/hospital-document/guide-grievance-notification-report.response';

@Injectable({
  providedIn: 'root'
})
export class GrievanceNotificationService extends CommonService {

  constructor(private httpClient: HttpClient) { super(); }  
  
  public deleteGrievanceNotification(idGuideGrievanceNotification: number): Observable<ReturnStruct> {

    let uri = `GrievanceNotification/DeleteGuideGrievanceNotification/idGuideGrievanceNotification/${idGuideGrievanceNotification}`;

    return this.httpClient.delete<ReturnStruct>(environment.urlApiHospitalDocument + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
  
  public getAll(): Observable<GetListGrievanceNotificationResponse> {
    let uri = `GrievanceNotification/getAllGrievanceNotification`;

    return this.httpClient.get<GetListGrievanceNotificationResponse>(environment.urlApiHospitalDocument + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  public getGuideGrievanceNotificationReport(idGuideGrievanceNotification: number): Observable<GuideGrievanceNotificationReportResponse> {
    let uri = `GrievanceNotification/GetGuideGrievanceNotificationReport/idGuideGrievanceNotification/${idGuideGrievanceNotification}`;

    return this.httpClient.get<GuideGrievanceNotificationReportResponse>(environment.urlApiHospitalDocument + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getGrievanceDefaultReport(idGrievanceNotification: number): Observable<GuideGrievanceNotificationReportResponse> {
    let uri = `GrievanceNotification/GetGrievanceNotificationDefaultGovernmentReport/idGrievanceNotification/${idGrievanceNotification}?`;

    return this.httpClient.get<GuideGrievanceNotificationReportResponse>(environment.urlApiHospitalDocument + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}